import { render, staticRenderFns } from "./industrialChain.vue?vue&type=template&id=7aca90ba&scoped=true&"
import script from "./industrialChain.vue?vue&type=script&lang=js&"
export * from "./industrialChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aca90ba",
  null
  
)

export default component.exports